// extracted by mini-css-extract-plugin
export var deliveryRow = "_t2-a";
export var fixedHeight = "_t2-4";
export var freightLogo = "_t2-9";
export var fullWidth = "_t2-3";
export var priceColumn = "_t2-5";
export var radioSelected = "_t2-7";
export var radioUnselected = "_t2-6";
export var selectedOption = "_t2-2";
export var selectedOptionContainer = "_t2-1";
export var selection = "_t2-0";
export var tallSkeletonText = "_t2-8";